<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-input size="small" v-model.trim="query.account" clearable placeholder="员工手机号"
					class="handle-input mr10" style="width: 180px"></el-input>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="handleSearch">搜索</el-button>
			</div>

			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				v-loading="loading" :cell-style="{ padding: '6px' }" stripe>
				<el-table-column prop="devicecode" label="设备" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.devicecode == 'applet'">小程序</el-tag>
						<el-tag v-else>{{ scope.row.devicecode }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="ip" label="ipv4地址" align="center"></el-table-column>
				<el-table-column prop="code" label="设备编码" align="center" width="480px"></el-table-column>
				<el-table-column prop="idWorker" label="token" align="center" width="200px">
					<template #default="scope">
						<el-tooltip class="item" effect="dark" placement="top-start">
							<template #content>
								<div style="display: flex; flex-direction: column;">
									<div style='width: 200px;overflow: hidden;'>{{scope.row.idWorker}}</div>
								</div>
							</template>
							<span style="width: 200px;cursor: pointer;display: flex;overflow: hidden;height: 30px;"
								@click="copyUrl(scope.row.idWorker)">{{scope.row.idWorker}}</span>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="loginTime" label="登录时间" align="center"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		getloginRecord
	} from '../api/index.js';
	export default {
		name: 'userPhone',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					account: ''
				},
				tableData: []
			};
		},
		created() {
			const role = localStorage.getItem('ms_role');
		},
		methods: {


			getData() {
				let data = {
					userPhone: this.query.account
				};
				this.loading = true;
				getloginRecord(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.loginList;
					} else {
						this.$message.error(res.message);
					}
				});
			},

			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			copyUrl(item) {
				let cInput = document.createElement('input');
				cInput.value = item;
				document.body.appendChild(cInput);
				cInput.select();
				document.execCommand('copy');
				this.$message.success('复制成功');
				document.body.removeChild(cInput);
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;
		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #f56c6c;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}

	/deep/.el-popper.is-dark {
		background: #4a5568;
		color: #fff;
		max-width: 200px;
		width: 200px !important;
	}
</style>